// extracted by mini-css-extract-plugin
export default {"heading":"productImages_heading__8aKL8","grid":"productImages_grid__Pkodf","card":"productImages_card__TkbjQ","image":"productImages_image__9QC8A"};